import { CHANGE_LOCALE } from './'

export function changeLocale(locale) {
   return {
      type: CHANGE_LOCALE,
      payload: locale,
   };
}